export default {
  data: function data() {
    return {};
  },
  methods: {
    openNetworkSecurity: function openNetworkSecurity() {
      window.open('https://xyt.xcc.cn/getpcInfo?sn=1427192787672256512&language=CN&certType=8&url=*.pujian.com', '_blank');
    }
  }
};